import React from 'react'
import { ListRolTable } from './ListRolTable'

export const Roles = () => {
    return (
        <div className='grid xl:grid-cols-1 gap-2'>
            <ListRolTable />
        </div>
    )
}